import {
    deLocalizeNumberString,
} from '~shared/utils/currencyUtils';

export const systemDecimalFormat = (number) => {
    let output = deLocalizeNumberString(String(number));
    output = Math.round(output * 100) / 100;

    return output.toFixed(2);
};
